import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import Navbar from "../../../Components/Navbar";
import { fetchProfile } from "../../../utils/fetchProfile";
import SearchBarSetupProduct from "../../../Components/SearchBarSetup";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import {
  Autocomplete,
  TextField,
  IconButton,
  Modal,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Paper,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  fetchDataProductMaster,
  fetchExportDataProductMaster,
  exportproductmastersetup,
} from "./DataUtil";
import ImportModalSetup from "./Modalimport";
import { Slide, toast } from "react-toastify";

// custom css for modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

// button style
const BootstrapButton = styled(Button)({
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  borderRadius: "4px",
  color: "#fff",
  fontSize: { xs: "14px", sm: "16px" },
  padding: "4px 10px",
  textTransform: "none",
  "&:hover": {
    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
  },
});

function SetupBrandCategoryMasterProduct() {
  const [sortBy, setSortBy] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [datacategory, setdatacategory] = useState([]);
  const [dataBrand, setdataBrand] = useState([]);
  const [dataPrincipal, setdataPrincipal] = useState([]);
  const [dataBrandCategoryMaster, setdataBrandCategoryMaster] = useState([]);
  const [selectedExportType, setSelectedExportType] = useState(
    "brand_category_master"
  );
  const [searchDataValue, setSearchDataValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);
  const accessToken = Cookies.get("access_token") || "";
  const [searchBarValue, setSearchBarValue] = useState("brand-category-master");
  const [modalAddCreate, setModalAddCreate] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [pageBrandCategoryMaster, setPageBrandCategoryMaster] = useState(0);
  const [rowsPerPageBrandCategoryMaster, setRowsPerPageBrandCategoryMaster] =
    useState(10);
  const [totalRowsBrandCategoryMaster, setTotalRowsBrandCategoryMaster] =
    useState(0);

  //import
  const [openDialogImport, setOpenDialogImport] = useState(false);

  // untuk membatas (?page=1&size=10)

  {
    /*function view data*/
  }
  async function fetchProductCategory() {
    try {
      const queryParams = new URLSearchParams();

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/category-master` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          authorization: "Bearer " + accessToken,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setdatacategory(data.data);
      }
    } catch (e) {
      console.error(e);
    }
  }

  async function fetchProductBrand() {
    try {
      const queryParams = new URLSearchParams();

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/brand-master` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          authorization: "Bearer " + accessToken,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setdataBrand(data.data);
      }
    } catch (e) {
      console.error(e);
    }
  }

  async function fetchProductPrincipal() {
    try {
      const queryParams = new URLSearchParams();

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/principal-master` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          authorization: "Bearer " + accessToken,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setdataPrincipal(data.data);
      }
    } catch (e) {
      console.error(e);
    }
  }

  async function fetchBrandCategoryMaster() {
    try {
      const queryParams = new URLSearchParams();

      if (
        pageBrandCategoryMaster !== undefined &&
        pageBrandCategoryMaster !== null
      ) {
        queryParams.append("page", pageBrandCategoryMaster + 1);
      }

      if (rowsPerPageBrandCategoryMaster) {
        queryParams.append("size", rowsPerPageBrandCategoryMaster);
      }

      if (searchDataValue) {
        queryParams.append("column_value", searchDataValue);
        queryParams.append("column_operator", "LIKE");
      }

      queryParams.append("sort_by", sortBy);
      queryParams.append("sort_order", sortOrder);

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/brand-category-master` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          authorization: "Bearer " + accessToken,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setdataBrandCategoryMaster(data.data);
        setTotalRowsBrandCategoryMaster(data.pagination_info.total);
      } else {
        setdataBrandCategoryMaster([]);
        setTotalRowsBrandCategoryMaster(0);
      }
    } catch (e) {
      console.error(e);
    }
  }

  const [selectedCategory, setselectedCategory] = useState(
    localStorage.getItem("selectedCategory") || "all"
  );
  const [selectedBrand, setselectedBrand] = useState(
    localStorage.getItem("selectedBrand") || "all"
  );
  const [selectedPrincipal, setselectedPrincipal] = useState(
    localStorage.getItem("selectedPrincipal") || "all"
  );
  const [selectedStockunit, setselectedStockunit] = useState(
    localStorage.getItem("selectedStockunit") || "all"
  );
  const [selectedPacksize, setselectedPacksize] = useState(
    localStorage.getItem("selectedPacksize") || "all"
  );
  const [selectedPacktype, setselectedPacktype] = useState(
    localStorage.getItem("selectedPacktype") || "all"
  );
  const [selectedFlavour, setselectedFlavour] = useState(
    localStorage.getItem("selectedFlavour") || "all"
  );
  const [selectedUnitvol, setselectedUnitvol] = useState(
    localStorage.getItem("selectedUnitvol") || "all"
  );
  const [selectedBrandCategoryMaster, setselectedBrandCategoryMaster] =
    useState(localStorage.getItem("selectedBrandCategoryMaster") || "all");

  const handleExportData = async () => {
    await fetchDataProductMaster(
      accessToken,
      setIsLoading,
      setFilteredRows,
      "brand-category-master", // Endpoint
      selectedCategory,
      selectedBrand,
      selectedPrincipal,
      selectedStockunit,
      selectedPacksize,
      selectedPacktype,
      selectedFlavour,
      selectedUnitvol,
      selectedBrandCategoryMaster
    );

    // Panggil fetchExportDataStoreMaster dengan parameter yang sesuai
    fetchExportDataProductMaster(
      accessToken,
      setIsLoading,
      selectedExportType,
      selectedCategory,
      selectedBrand,
      selectedPrincipal,
      selectedStockunit,
      selectedPacksize,
      selectedPacktype,
      selectedFlavour,
      selectedUnitvol,
      selectedBrandCategoryMaster
    );
  };

  const handleChangePageBrandCategoryMaster = (event, newPage) => {
    setPageBrandCategoryMaster(newPage);
  };

  const handleChangeRowsPerPageBrandCategoryMaster = (event) => {
    setRowsPerPageBrandCategoryMaster(parseInt(event.target.value, 10));
    setPageBrandCategoryMaster(0);
  };

  // funtionbuttoncreate
  const handleAddCreate = () => {
    setModalAddCreate(true);
  };

  const handleSetupInputChange = (event) => {
    const { name, value } = event.target;
    setNewBrandCategoryMaster((prevBrandCategoryMaster) => ({
      ...prevBrandCategoryMaster,
      [name]: value,
    }));
  };

  //Brand Category Master
  const [newBrandCategoryMaster, setNewBrandCategoryMaster] = useState({
    category_master_id: "",
    principal_master_id: "",
    brand_master_id: "",
    reported_brand: true,
    reported_sku: false,
  });

  const handleCreateBrandCategoryMaster = async () => {
    try {
      const token = Cookies.get("access_token");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/brand-category-master`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newBrandCategoryMaster),
        }
      );

      if (response.status === 201) {
        alert("Brand Category Master Berhasil dibuat!");
        setModalAddCreate(false);
        setNewBrandCategoryMaster({});
        setPageBrandCategoryMaster(0);
        await fetchBrandCategoryMaster();
      } else if (response.status === 400) {
        const data = await response.json();
        alert(data.detail);
      } else {
        alert("Brand Category Master Gagal Dibuat!");
      }
    } catch (error) {
      console.error("Error creating Brand Category Master", error);
    }
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setHasPrincipalChanged(false);
  };

  /* Update Brand Category Master */
  const HandleEditBrandCategoryMaster = async (row) => {
    setEditBrandCategoryMasterId(row.id);
    setEditModalOpen(true);
    setEditedBrandCategoryMaster(row);
    setSelectedPrincipalOriginal(String(row.principal_master_id));
    setSelectedPrincipalNew(String(row.principal_master_id));
  };
  const [editBrandCategoryMasterId, setEditBrandCategoryMasterId] =
    useState(null);
  const [selectedPrincipalOriginal, setSelectedPrincipalOriginal] =
    useState("");
  const [selectedPrincipalNew, setSelectedPrincipalNew] = useState("");
  const [editedBrandCategoryMaster, setEditedBrandCategoryMaster] = useState({
    category_master_id: "",
    principal_master_id: "",
    brand_master_id: "",
    reported_brand: true,
    reported_sku: false,
  });
  const handleUpdateBrandCategoryMaster = async () => {
    setIsLoading(true);
    if (editBrandCategoryMasterId) {
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/brand-category-master/${editBrandCategoryMasterId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedBrandCategoryMaster),
          }
        );

        if (response.status === 200) {
          alert("Brand Category Master Berhasil di update");
          setEditModalOpen(false);
          await fetchBrandCategoryMaster();
        } else {
          alert("Brand Category Master gagal di update");
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [hasPrincipalChanged, setHasPrincipalChanged] = useState(false);

  const handleOpenConfirmModal = () => {
    if (selectedPrincipalOriginal === selectedPrincipalNew) {
      handleUpdateBrandCategoryMaster();
    } else {
      setIsConfirmModalOpen(true);
    }
  };

  const closeConfirmModal = () => {
    if (selectedPrincipalOriginal === selectedPrincipalNew) {
      setHasPrincipalChanged(false);
    } else if (selectedPrincipalOriginal !== selectedPrincipalNew) {
      setHasPrincipalChanged(true);
    }
    setIsConfirmModalOpen(false);
  };

  //delete brand category master
  const [deleteModalId, setDeleteModalId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteBrandCategoryMaster = (row) => {
    setDeleteModalId(row.id);
    setIsModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsModalOpen(false);
    setDeleteModalId(null);
  };

  const handleDelete = async () => {
    if (deleteModalId) {
      try {
        const token = Cookies.get("access_token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/brand-category-master/${deleteModalId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const message = await response.json();
        if (response.ok) {
          alert("Data berhasil dihapus!");
          setIsModalOpen(false);
          setDeleteModalId(null);
          setPageBrandCategoryMaster(0);
          await fetchBrandCategoryMaster();
        } else if (response.status === 400) {
          alert(message.detail);
        } else if (response.status === 404) {
          alert(message.detail);
        } else {
          alert("Gagal menghapus data!");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const dataSetupOptions = [
    { label: "Category", value: "category" },
    { label: "Brand", value: "brand" },
    { label: "Principal", value: "principal" },
    { label: "Stock Unit", value: "stock-unit" },
    { label: "Unitvol", value: "unitvol" },
    {
      label: "Brand Category Master",
      value: "brand-category-master",
    },
  ];

  //function serach bar
  const handleTableSelection = (newValue) => {
    if (newValue) {
      setSearchBarValue(newValue.value);
      setTimeout(() => {
        window.location.href = newValue.value;
      }, 100);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProductCategory();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProductBrand();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProductPrincipal();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchBrandCategoryMaster();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [
    pageBrandCategoryMaster,
    rowsPerPageBrandCategoryMaster,
    searchBarValue,
    accessToken,
    sortBy,
    sortOrder,
    searchDataValue
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
      ]);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchDataProductMaster(accessToken, setIsLoading, setFilteredRows);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearchDataValue(inputValue);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [inputValue]);

  //import
  const [fileUrl, setFileUrl] = useState("");
  const [excelFile, setExcelFile] = useState("");

  const handleImport = () => {
    setOpenDialogImport(true);
  };
  const handleCloseDialog = () => {
    setOpenDialogImport(false);
    setFileUrl("");
    setExcelFile("");
  };

  // export product master setup template
  async function exportproductmastersetupTemplate() {
    setIsLoading(true);
    const blob = await exportproductmastersetup(
      accessToken,
      "template",
      "api/v1/product-master/export/setup_template",
      {}
    );
    if (blob) {
      // throw data as blob then download it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Template Product Master Setup.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      toast.error("Gagal mendownload template Setup Product Master!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  }

  // import setup Product master
  async function importProductmastersetupTemplate() {
    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/product-master/import_product_master_setup`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      if (response.status === 201) {
        toast.success("Upload Product Master Setup berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        // setFileUrl('')

        // close
        setOpenDialogImport(false);
      } else if (response.status === 200) {
        // throw data as blob then download it when validation on excel got fail
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Product Master Setup Error.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        toast.error("Ada masalah di excel. Periksa kembali isi excel!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("Gagal mengimport Product Master Setup!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error(
          "Failed to import Product Master Setup template:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error importing Product Master Setup template:", error);
    }
  }

  const handleUpload = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    importProductmastersetupTemplate();
    setIsLoading(false);
  };

  // sorting
  const handleSort = (column) => {
    const isSorting = sortBy === column && sortOrder === "asc";
    setSortOrder(isSorting ? "desc" : "asc");
    setSortBy(column);
  };

  const sortTableCell = (label, sortByKey) => (
    <TableCell
      style={tableCellStyle}
      sx={{ border: 1, borderColor: "grey.300" }}
    >
      <TableSortLabel
        active={sortBy === sortByKey}
        direction={sortOrder}
        onClick={() => handleSort(sortByKey)}
        sx={{
          color: "#FFF !important",
          "&:hover": {
            color: "#FFF",
          },
          "& .MuiTableSortLabel-icon": {
            color: "#FFF !important",
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <div>
      <Navbar
        active="Setup Product Master"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginTop: "30px",
            marginBottom: "20px",
          }}
        >
          <Autocomplete
            options={dataSetupOptions}
            getOptionLabel={(option) => option.label}
            value={
              dataSetupOptions.find(
                (option) => option.value === searchBarValue
              ) || null
            }
            onChange={(e, newValue) => handleTableSelection(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Cari Kategori"
                size="small"
                style={{ width: "300px" }}
              />
            )}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            disableClearable
          />
          <TextField
            variant="outlined"
            size="small"
            label="Search"
            sx={{ ml: 0 }}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />

          {/* button */}
          <div className="button-setup" style={{ display: "flex", gap: "5px" }}>
            {searchBarValue !== "Category" && (
              <>
                <BootstrapButton
                  disableRipple
                  onClick={handleAddCreate}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Add"}
                </BootstrapButton>
                <BootstrapButton
                  onClick={() => handleImport()}
                  disableRipple
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Upload"}
                </BootstrapButton>
              </>
            )}
            <BootstrapButton
              disableRipple
              onClick={handleExportData}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Download"}
            </BootstrapButton>
          </div>
        </div>
        <div>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 650 }}>
              <Table
                aria-label="simple table"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  borderCollapse: "collapse",
                }}
              >
                <TableHead sx={{ backgroundColor: "rgb(6,157,174)" }}>
                  <TableRow>
                    {sortTableCell("ID", "id")}
                    {sortTableCell("Category", "category_master")}
                    {sortTableCell("Brand", "brand_master")}
                    {sortTableCell("Principal Master", "principal_master")}
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      MT Reported Brand
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      MT Reported SKU
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataBrandCategoryMaster.map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.id}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.category_master}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.brand_master}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.principal_master}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.reported_brand ? "true" : "false"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.reported_sku ? "true" : "false"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        <Tooltip
                          title="Edit Brand Category Master"
                          onClick={() => HandleEditBrandCategoryMaster(row)}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title="Delete Brand Category Master"
                          onClick={() => handleDeleteBrandCategoryMaster(row)}
                        >
                          <IconButton>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                  {dataBrandCategoryMaster.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={totalRowsBrandCategoryMaster}
              rowsPerPage={rowsPerPageBrandCategoryMaster}
              page={pageBrandCategoryMaster}
              onPageChange={handleChangePageBrandCategoryMaster}
              onRowsPerPageChange={handleChangeRowsPerPageBrandCategoryMaster}
            />
          </Paper>
        </div>

        {/* create product */}
        <Modal
          open={modalAddCreate}
          onClose={() => setModalAddCreate(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <Tooltip title="Close Modal">
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => setModalAddCreate(false)}
                sx={{ position: "absolute", top: 20, right: 30 }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <div className="Create-BrandCategoryMaster">
              <h2 className="mb-2">Create Brand Category Master</h2>
              <div>
                <Autocomplete
                  label="CATEGORY"
                  name="category_master_id"
                  value={
                    datacategory?.find(
                      (option) =>
                        option.id === newBrandCategoryMaster.category_master_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "category_master_id",
                        value: newValue ? newValue.id : "",
                      },
                    });
                  }}
                  options={datacategory || []}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="CATEGORY"
                      sx={{ width: "100%", mb: 2 }}
                    />
                  )}
                />
              </div>

              <div>
                <Autocomplete
                  label="BRAND"
                  name="brand_master_id"
                  value={
                    dataBrand?.find(
                      (option) =>
                        option.id === newBrandCategoryMaster.brand_master_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "brand_master_id",
                        value: newValue ? newValue.id : "",
                      },
                    });
                  }}
                  options={dataBrand || []}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="BRAND"
                      sx={{ width: "100%", mb: 2 }}
                    />
                  )}
                />
              </div>

              <div>
                <Autocomplete
                  label="PRINCIPAL MASTER"
                  name="principal_master_id"
                  value={
                    dataPrincipal?.find(
                      (option) =>
                        option.id === newBrandCategoryMaster.principal_master_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "principal_master_id",
                        value: newValue ? newValue.id : "",
                      },
                    });
                  }}
                  options={dataPrincipal || []}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="PRINCIPAL MASTER"
                      sx={{ width: "100%", mb: 2 }}
                    />
                  )}
                />
              </div>
              <div>
                <FormControl component="fieldset" sx={{ width: "100%", mb: 2 }}>
                  <FormLabel component="legend">REPORTED BRAND</FormLabel>
                  <RadioGroup
                    aria-label="reported_brand"
                    name="reported_brand"
                    value={newBrandCategoryMaster.reported_brand}
                    onChange={handleSetupInputChange}
                    // sx={{
                    //   display: "flex",
                    //   flexDirection: "row",
                    //   justifyContent: "space-between",
                    // }}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div>
                <FormControl component="fieldset" sx={{ width: "100%", mb: 2 }}>
                  <FormLabel component="legend">REPORTED SKU</FormLabel>
                  <RadioGroup
                    aria-label="reported_sku"
                    name="reported_sku"
                    value={newBrandCategoryMaster.reported_sku}
                    onChange={handleSetupInputChange}
                    // sx={{
                    //   display: "flex",
                    //   flexDirection: "row",
                    //   justifyContent: "space-between",
                    // }}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div>
                <BootstrapButton
                  disableRipple
                  sx={{ width: "100%", mt: 2, height: 50, mb: 3 }}
                  onClick={handleCreateBrandCategoryMaster}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Submit"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        {/* Update Product */}
        <Modal
          open={editModalOpen}
          onClose={handleCloseEditModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <div className="BrandCategoryMaster-Update">
              <h2>Edit Brand Category Master</h2>
              <div>
                <Autocomplete
                  name="category_master_id"
                  value={
                    datacategory?.find(
                      (option) =>
                        option.id ===
                        editedBrandCategoryMaster.category_master_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedBrandCategoryMaster({
                      ...editedBrandCategoryMaster,
                      category_master_id: newValue ? newValue.id : "",
                    });
                  }}
                  options={datacategory || []}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Category"
                      sx={{ width: "100%", mb: 2 }}
                    />
                  )}
                />
                <Autocomplete
                  name="brand_master_id"
                  value={
                    dataBrand.find(
                      (option) =>
                        option.id === editedBrandCategoryMaster.brand_master_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedBrandCategoryMaster({
                      ...editedBrandCategoryMaster,
                      brand_master_id: newValue ? newValue.id : "",
                    });
                  }}
                  options={dataBrand || []}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Brand"
                      sx={{ width: "100%", mb: 2 }}
                    />
                  )}
                />
                <Autocomplete
                  name="principal_master_id"
                  value={
                    dataPrincipal?.find(
                      (option) =>
                        option.id ===
                        editedBrandCategoryMaster.principal_master_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue ? newValue.id : "";
                    setEditedBrandCategoryMaster({
                      ...editedBrandCategoryMaster,
                      principal_master_id: value,
                    });
                    setSelectedPrincipalNew(value);
                    setHasPrincipalChanged(selectedPrincipalOriginal !== value);
                  }}
                  options={dataPrincipal || []}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Principal Master"
                      sx={{ width: "100%", mb: 2 }}
                    />
                  )}
                />
                <FormControl component="fieldset" sx={{ width: "100%", mb: 2 }}>
                  <FormLabel component="legend">Reported Brand</FormLabel>
                  <RadioGroup
                    aria-label="reported_brand"
                    name="reported_brand"
                    value={editedBrandCategoryMaster.reported_brand}
                    onChange={(e) =>
                      setEditedBrandCategoryMaster({
                        ...editedBrandCategoryMaster,
                        reported_brand: e.target.value === "true",
                      })
                    }
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>

                <FormControl component="fieldset" sx={{ width: "100%", mb: 2 }}>
                  <FormLabel component="legend">Reported SKU</FormLabel>
                  <RadioGroup
                    aria-label="reported_sku"
                    name="reported_sku"
                    value={editedBrandCategoryMaster.reported_sku}
                    onChange={(e) =>
                      setEditedBrandCategoryMaster({
                        ...editedBrandCategoryMaster,
                        reported_sku: e.target.value === "true",
                      })
                    }
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    variant="outlined"
                    disableRipple
                    sx={{
                      width: "50%",
                      height: 50,
                      mt: 2,
                      color: "#b34469",
                      borderColor: "#b34469",
                    }}
                    onClick={handleCloseEditModal}
                  >
                    Cancel
                  </Button>
                  <BootstrapButton
                    disableRipple
                    sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                    onClick={handleOpenConfirmModal}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "UPDATE"}
                  </BootstrapButton>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={isConfirmModalOpen}
          onClose={closeConfirmModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              ...style,
              maxWidth: 800,
              margin: "0 auto",
              maxHeight: "700px",
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            <p>
              apakah principal tsb akan dan diterapkan (update) ke semua product
              yg ada di product_master?{" "}
            </p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                variant="outlined"
                onClick={() => setIsConfirmModalOpen(false)}
                sx={{ width: "45%" }}
              >
                No
              </Button>
              <Button
                onClick={() => {
                  setIsConfirmModalOpen(false);
                  handleUpdateBrandCategoryMaster();
                }}
                sx={{ width: "45%" }}
              >
                Yes
              </Button>
            </div>
          </Box>
        </Modal>

        <Modal
          open={isModalOpen}
          onClose={handleCloseDeleteModal}
          aria-labelledby="delete-modal-title"
          aria-describedby="delete-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: "5px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography id="delete-modal-title" variant="h6" component="h2">
              Confirm Delete
            </Typography>
            <Typography id="delete-modal-description" sx={{ mt: 2 }}>
              Are you sure you want to delete this item?
            </Typography>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <BootstrapButton
                onClick={handleCloseDeleteModal}
                variant="outlined"
                sx={{ mr: 2 }}
              >
                Cancel
              </BootstrapButton>
              <BootstrapButton onClick={handleDelete} color="error">
                Delete
              </BootstrapButton>
            </Box>
          </Box>
        </Modal>

        <ImportModalSetup
          open={openDialogImport}
          onClose={handleCloseDialog}
          title={"Upload Setup Product Master"}
          buttonTitle={"Upload"}
          fileUrl={fileUrl}
          handleSubmit={handleUpload}
          handleChange={{
            excel: setExcelFile,
            fileUrl: setFileUrl,
          }}
          handleExport={exportproductmastersetupTemplate}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

export default SetupBrandCategoryMasterProduct;
